<nav class="tp-nav">
  <div class="tp-nav-section">Mon entreprise</div>

  <a class="tp-nav-item">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
    <span>Collaborateurs</span>
  </a>

  <div class="tp-nav-group">Avantages employé</div>

  <a *ngFor="let ticket of filteredTickets"
     [routerLink]="ticket.route" routerLinkActive="active"
     class="tp-nav-item" (click)="newMessage(ticket.label)">
    <img [src]="ticket.icon" alt="" class="tp-nav-icon">
    <span>{{ ticket.label }}</span>
  </a>

  <a routerLink="/company/solde" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Solde')">
    <img src="assets/cash.svg" alt="" class="tp-nav-icon">
    <span>Mon solde</span>
  </a>

  <div class="tp-nav-section">Préférences</div>

  <a routerLink="/company/aide" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Aide')">
    <img src="assets/help.svg" alt="" class="tp-nav-icon">
    <span>Besoin d'aide</span>
  </a>

  <a routerLink="/company/profil" routerLinkActive="active" class="tp-nav-item" (click)="newMessage('Profil')">
    <img src="assets/profile.svg" alt="" class="tp-nav-icon">
    <span>Mon profil</span>
  </a>

  <div class="tp-nav-footer">
    <button type="button" class="tp-nav-item tp-nav-logout" (click)="logout()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
      <span>Déconnexion</span>
    </button>
  </div>
</nav>